export default function DoubleArrow() {
  return (
    <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.01192 0.430571C1.32641 0.161005 1.79989 0.197426 2.06946 0.51192L8.06946 7.51192C8.3102 7.79279 8.3102 8.20724 8.06946 8.48811L2.06946 15.4881C1.79989 15.8026 1.32641 15.839 1.01192 15.5695C0.697426 15.2999 0.661005 14.8264 0.930571 14.5119L6.51221 8.00001L0.930571 1.48811C0.661005 1.17361 0.697426 0.700138 1.01192 0.430571ZM5.01212 0.430675C5.32661 0.161108 5.80008 0.19753 6.06965 0.512024L12.0697 7.51202C12.3104 7.79289 12.3104 8.20734 12.0697 8.48821L6.06965 15.4882C5.80008 15.8027 5.32661 15.8391 5.01212 15.5696C4.69762 15.3 4.6612 14.8265 4.93077 14.512L10.5124 8.00012L4.93077 1.48821C4.6612 1.17372 4.69762 0.700242 5.01212 0.430675Z"
        fill="#0D0B26"
      />
    </svg>
  );
}
